import React, {useMemo, useState} from "react";
import {Box} from "@mui/material";

import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {FilterBox} from "../../../../designSystem/components/FilterBox";
import {OrganizationCard} from "../../../../designSystem/components/OrganizationCard";

import TotalView from "../../../../components/TotalView/TotalView";
import {MultiSelection} from "../../../../components/MultiSelection/MultiSelection";
import {BackdropOverlay} from "../../../../components/BackdropOverlay";

import {filterMedicalOrganizationVaccines} from "../../model/filterMedicalOrganizationVaccines";
import {useMedicalOrganizationVaccines} from "../../hooks/useMedicalOrganizationVaccines";
import {useMedicalOrganizationVaccinesFilter} from "../../hooks/useMedicalOrganizationVaccinesFilter";
import {REGION_OPTIONS, VACCINE_TYPE_OPTIONS} from "../../../../utils/constants";

export const VaccineListFeature = () => {
  const [keyword, setKeyword] = useState<string>("");

  const { medicalOrganizationVaccines, isLoading } = useMedicalOrganizationVaccines();
  const {
    selectedVaccineTypes,
    setSelectedVaccineTypes,
    selectedRegions,
    setSelectedRegions,
    isShowVaccineTypeSelect,
    isShowRegionSelect,
    isOverlayVisible,
    toggleVaccineTypePanel,
    toggleRegionPanel,
    closeAllPanels,
    onVaccineTypeSelectionCompleted,
    onRegionSelectionCompleted,
  } = useMedicalOrganizationVaccinesFilter();

  const filteredMedicalOrganizationVaccines = useMemo(() => {
    return filterMedicalOrganizationVaccines({
      medicalOrganizationVaccines,
      keyword,
      selectedVaccineTypes,
      selectedRegions
    })
  }, [medicalOrganizationVaccines, keyword, selectedVaccineTypes, selectedRegions])

  if (isLoading)
    return <LoadingView />

  return (
    <Box height={"100%"} className={"flex flex-1 flex-col bg-gray-100"}>
      <Box className={"flex flex-row justify-between items-center gap-2 pl-4 pr-2 bg-white"}>
        <Box className={"flex-1"}>
          <BaseInput
            value={keyword}
            placeholder={"請輸入關鍵字"}
            onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => {
              setKeyword(e.target.value)
            }}
          />
        </Box>
        <TotalView numberOfData={filteredMedicalOrganizationVaccines.length}/>
      </Box>
      <Box className={"relative"}>
        <Box
          className="flex flex-row justify-evenly items-center gap-2 px-2 pt-2 pb-3 z-20 shadow-md bg-white"
        >
          <FilterBox
            label="疫苗類別"
            selectedItems={selectedVaccineTypes}
            isShowSelect={isShowVaccineTypeSelect}
            onClick={toggleVaccineTypePanel}
          />
          <FilterBox
            label="鄉鎮市"
            selectedItems={selectedRegions}
            isShowSelect={isShowRegionSelect}
            onClick={toggleRegionPanel}
          />
        </Box>
        <MultiSelection
          isShow={isShowVaccineTypeSelect}
          options={VACCINE_TYPE_OPTIONS}
          defaultSelected={['不限']}
          onChangeSelected={(values: React.SetStateAction<string[]>) => setSelectedVaccineTypes(values)}
          onClickCompleted={onVaccineTypeSelectionCompleted}
        />
        <MultiSelection
          isShow={isShowRegionSelect}
          options={REGION_OPTIONS}
          defaultSelected={['不限']}
          onChangeSelected={(values: React.SetStateAction<string[]>) => setSelectedRegions(values)}
          onClickCompleted={onRegionSelectionCompleted}
        />
      </Box>

      {isOverlayVisible && <BackdropOverlay onClick={closeAllPanels} /> }

      <Box className={"flex flex-col h-[calc(100%-178px)] px-4 py-2 overflow-y-scroll"}>
        {filteredMedicalOrganizationVaccines.map((medicalOrganizationVaccine, index) => (
          <OrganizationCard
            key={`organization-${index}`}
            imageUrl="/img/organization_placeholder.png" // Replace with actual image URL
            title={medicalOrganizationVaccine.name}
            categories={medicalOrganizationVaccine.vaccines}
            region={medicalOrganizationVaccine.region}
            address={medicalOrganizationVaccine.address}
            phone={medicalOrganizationVaccine.telephone}
            url={medicalOrganizationVaccine.officialWeb}
            keyword={keyword.trim()}
          />
        ))}
      </Box>
    </Box>
  );
}